import { FormControl } from '@angular/forms';

import { isValid, parse } from 'date-fns';

export function validateDate(c: FormControl) {
    let DATE_REGEX = /^(1[0-2]|[1-9])\/([1-2][0-9]|3[0-1]|[1-9])\/(20)?(\d{2})\s+(1[0-2]|[1-9]):([0-5][0-9])\s*([aApP][mM])$/;

    let dateval = c.value;

    if (!dateval) return null; // Nothing to validate

    let valid = true;

    // First check to see if the value passes the basic date regex.
    if (!DATE_REGEX.test(dateval)) valid = false;

    if (valid) {
        let bits = dateval.match(DATE_REGEX);

        // Now, try to parse it into a date object using date-fns.
        let dateobj = parse(dateval);

        if (!isValid(dateobj)) valid = false;

        if (valid) {
            // Compare what was returned against a date object using the individual parts.
            if (dateobj.getMonth() != (bits[1]-1) || dateobj.getDate() != (bits[2])) valid = false;
        }
    }

    return valid ? null : {
        validateEmail: {
            valid: false
        }
    };
}


// WEBPACK FOOTER //
// ./src/validators/date.validator.ts